import React, { useState } from "react";
import "./TirumalaDC.css";
import axios from "axios";
import { useEffect } from "react";
import logoImage from "../logo.webp";
import SuccessModal from "../Modals/SuccessModal/SuccessModal";
import ErrorModal from "../Modals/ErrorModal/ErrorModal";
import ClipLoader from "react-spinners/ClipLoader";
import { branchList } from "../LenderBranchLists/LenderBranchLists";
import { Info } from "lucide-react";


const styles = {
  openButton: { padding: "10px", backgroundColor: "blue", color: "white" },
  dialogOverlay: { position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0, 0, 0, 0.5)", display: "flex", justifyContent: "center", alignItems: "center" },
  dialog: { backgroundColor: "white", padding: "20px", borderRadius: "10px", width: "400px", maxHeight: "80vh", overflowY: "auto" }, // Added maxHeight and overflowY for scrolling
  dialogTitle: { fontSize: "18px", fontWeight: "bold" },
  formSelection: { display: "flex", justifyContent: "space-between", marginBottom: "10px" },
  button: { padding: "10px", cursor: "pointer", margin: "5px", backgroundColor: "#4CAF50", color: "white", border: "none", borderRadius: "5px" },
  otpSection: { marginTop: "10px", textAlign: "center" },
  dialogContent: { marginTop: "10px" },
  question: { marginBottom: "10px" },
  label: { display: "block", marginBottom: "5px" },
  radioGroup: { display: "flex", gap: "10px" },
  radioLabel: { cursor: "pointer" },
  pdfSection: { marginTop: "10px", textAlign: "center" },
  link: { color: "blue", textDecoration: "underline" },
  footer: { marginTop: "10px", display: "flex", justifyContent: "space-between" },
  buttonCancel: { padding: "10px", backgroundColor: "red", color: "white" },
  buttonSave: { padding: "10px", backgroundColor: "blue", color: "white" },
};




const healthQuestion= [
  {
    key: "medicalHistory",
    label:
      "Have you ever suffered from or taken treatment, been hospitalized, or been recommended to take any investigations/medical treatment?",
  },
  {
    key: "insuranceHistory",
    label:
      "Has any of your Insurance Proposal / Policy or reinstatement of policy for Life, Health, or Critical Illness ever been withdrawn, deferred, declined, rejected, terminated, or offered with an extra premium?",
  },
  {
    key: "covidHistory",
    label:
      "Have you ever been hospitalized for COVID infection or its complications, or do you have any ongoing complications related to COVID infection?",
  },
  {
    key: "hazardousActivities",
    label:
      "Are you currently engaged in any hazardous activities?",
  },
]

const TirumalaDC = () => {
  const override: CSSProperties= {
    position: "absolute",
    top: "50%",
    left: "50%",
    backgroundColor:"green",
    transform: "translate(-50%, -50%)", // This centers the element
    display: "block",
    margin: "auto", // Centering in the parent container
    borderColor: "grey", // Border color for debugging
  };

  const [showPopup, setShowPopup] = useState(false);
const togglePopup = () => setShowPopup(!showPopup);
  const handleSuccessClose = () => setDataIsSent(false);
  const handleErrorClose = () => setDataIsNotSent(false);
  const [count, setCount] = useState(1);
  const [totalLoanAmount, setTotalLoanAmount] = useState(0);
  const [loanDetails, setLoanEntries] = useState([
    {
      loanAmount: "",
      loanSanctionDate: "",
      loanEndDate: "",
      loanType: "",
      lenderBranch: "",
      loanAccountNumber: "",
    },
  ]);
  const [loading, setLoading] = useState(false);
  const [popupResponse, setPopupResponse] = useState("");
  const [ErrorResponse, setErrorResponse] = useState("");
  const [ageLimitExceed, setAgeLimitExceed] = useState(false);
  const [open, setOpen] = useState(false);
  const [manualForm, setManualForm] = useState(false);
  const [hasAnyYesAnswer, setHasAnyYesAnswer] = useState(false);
  const [isManual, setIsManual] = useState(false);
  const [isDigital, setIsDigital] = useState(false);
  const [digitalVerify, setDigitalVerify] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [responses, setResponses] = useState({
    medicalHistory: "",
    insuranceHistory: "",
    covidHistory: "",
    hazardousActivities: "",
  });
  const [phoneNumber, setPhoneNumber] = useState("");
  const [singleManualForm, setSingleManualForm] = useState(false)
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [error, setError] = useState("");
  const [resendTimer, setResendTimer] = useState(30);
  const [serverOtp, setServerOtp] = useState(""); // Store OTP from API
  const [memberForm, setMemberForm] = useState(false)

  const pdfDownloadLink = "https://storage.googleapis.com/flash-v2/assets/Long%20Form%20Medical%20Questionnaire.pdf"; 
  const memmberShipFormLink = "https://storage.googleapis.com/flash-v2/assets/aviva_membership_form.pdf"

  // const handleResponseChange = (key, value) => {
  //   setResponses((prevResponses) => {
  //     const updatedResponses = { ...prevResponses, [key]: value };
  //     const allAnswered = Object.values(updatedResponses).every((response) => response !== "");
  //     // Check if any response is "Yes" and set manualForm to true
  //     const hasYesResponse = Object.values(updatedResponses).includes("yes");
  //     // setManualForm(hasYesResponse);

  //     if(allAnswered  && hasYesResponse){
  //       setSingleManualForm(true)
  //       setMemberForm(true)
  //     }
  //     if(allAnswered  && !hasYesResponse){
  //       setSingleManualForm(false)
  //       setMemberForm(true)
  //     }
  
  //     return updatedResponses;
  //   });
  // };

  const isLoanDetailsValid = () => {
    console.log("Validating loan details. Total entries:", loanDetails.length);
    
    loanDetails.forEach((entry, index) => {
      console.log(`Entry ${index + 1}:`, entry);
    });
  
    const isValid = loanDetails.length > 0 &&
      loanDetails.every((entry) =>
        entry.loanAmount !== '' &&
        entry.loanSanctionDate !== '' &&
        entry.loanAccountNumber !== '' &&
        entry.loanEndDate !== '' &&
        entry.loanType !== '' &&
        entry.lenderBranch !== ''
      );
  
    console.log("Overall loan validity:", isValid);
    return isValid;
  };
  

  const handleResponseChange = (key, value) => {
    setResponses((prevResponses) => {
      const updatedResponses = { ...prevResponses, [key]: value };
      const allAnswered = Object.values(updatedResponses).every((response) => response !== "");
      // Check if any response is "Yes" and set manualForm to true
      const hasYesResponse = Object.values(updatedResponses).includes("yes");
      // setManualForm(hasYesResponse);

      if(allAnswered  && hasYesResponse){
        setSingleManualForm(true)
        setHasAnyYesAnswer(true)
        setMemberForm(true)
      }
      if(allAnswered  && !hasYesResponse){
        setSingleManualForm(false)
        setHasAnyYesAnswer(false)
        setMemberForm(true)
      }
  
      return updatedResponses;
    });
  };


 
  

  //const anyYesResponse = Object.values(responses).includes("yes");

  const handleSubmitTnc = () => {
    if (isDigital && !otpVerified) {
      alert("Please verify OTP before proceeding.");
      return;
    }
    alert("Form submitted successfully!");
  };

  // Handle phone number input change
  const handlePhoneChange = (e) => {
    const input = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
    if (input.length <= 10) setPhoneNumber(input);
    if (input.length !== 10) setOtpSent(false); // Reset OTP if number is invalid
  };

  // Send OTP API Call
  const handleSendOTP = async () => {
    if (phoneNumber.length !== 10) {
      setError("Please enter a valid 10-digit phone number.");
      return;
    }

    try {
      setError("");
      // const response = await axios.post(
      // `https://flashaid-v3-dev-backened.flashaid.in/auth/v1/otp/generate?phoneNumber=%2B91${phoneNumber}`,
      // );
      const response = await axios.post(
        `https://flashaid-v3-prod-backend.flashaid.in/auth/v1/tirumala/generate-otp?phoneNumber=${phoneNumber}`
      );
      
      setOtpSent(true);
      setOtp(""); 
      // Start resend timer
      let timer = 30;
      setResendTimer(timer);
      const interval = setInterval(() => {
        timer--;
        setResendTimer(timer);
        if (timer === 0) clearInterval(interval);
      }, 1000);
    } catch (err) {
      setError("Failed to send OTP. Please try again.");
    }
  };

  // Handle OTP input change
  const handleOtpChange = (e) => {
    setOtp(e.target.value);
  };

  // Verify OTP by comparing with stored OTP
  const handleVerifyOTP = async () => {
    if (otp.length !== 6) {
      setError("Please enter a valid 6-digit OTP.");
      return;
    }
    try {
      // const verifyotp = await axios.post(
      //   `https://flashaid-v3-dev-backened.flashaid.in/auth/v1/otp/verify?phoneNumber=%2B91${phoneNumber}&otp=${otp}`
      // );
      const verifyotp = await axios.post(
        `https://flashaid-v3-prod-backend.flashaid.in/auth/v1/tirumala/verify-otp?phoneNumber=${phoneNumber}&otp=${otp}`
      );
      
      console.log("get",verifyotp)
  
      if (verifyotp.data.message === "OTP verified success") {
        setError("");
        setOtpVerified(true);
        alert("OTP Verified Successfully!")
      } else {
        setError("Invalid OTP. Please try again.");
        return;
      }
  
      console.log("OTP Verification Response:", verifyotp);
    } catch (error) {
      console.error("Login Error:", error);
      alert('Something went wrong during login. Please try again.');
    }
  };

  // Handle OTP Resend
  const handleResendOTP = () => {
    if (resendTimer === 0) handleSendOTP();
  };
  const handleLoanChange = (e, index) => {
    const { name, value } = e.target;

    // Extract the field name without the index
    const [fieldName, fieldIndex] = name.split("_");

    // Ensure index is correct
    if (parseInt(fieldIndex, 10) === index) {
      const updatedEntries = [...loanDetails];

      updatedEntries[index] = { ...updatedEntries[index], [fieldName]: value };
      setLoanEntries(updatedEntries);
      


      const newTotalLoanAmount = updatedEntries.reduce((total, entry) => {
        // Convert to number or default to 0 if invalid
        const loanAmount = parseFloat(entry.loanAmount) || 0;
        return total + loanAmount;
      }, 0);
      // Update the total loan amount state
      setTotalLoanAmount(newTotalLoanAmount);
    }
  };
  const addMoreLoans = (e) => {
    e.preventDefault();
    if (count < 15) {
      setLoanEntries([
        ...loanDetails,
        {
          loanAmount: "",
          loanSanctionDate: "",
          loanEndDate: "",
          loanType: "",
          lenderBranch: "",
          loanAccountNumber: "",
        },
      ]);
      setCount(count + 1);
    }
  };
  const validateEmail = (email) => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  };
  const validatePhoneNumber = (phoneNumber) => {
    const phonePattern = /^[6-9][0-9]{9}$/;
    return phonePattern.test(phoneNumber);
  };
  const validatePincode = (pincode) => {
    const pincodePattern = /^[1-9][0-9]{5}$/;
    return pincodePattern.test(pincode);
  };

  const [dataIsSent, setDataIsSent] = useState(false);
  const [dataIsNotSent, setDataIsNotSent] = useState(false);
  const [pricingData, setPricingData] = useState({});
  const [pricingDataGpa, setPricingDataGpa] = useState({});

  const [cvgSum, setCvgSum] = useState("");
  const [tenure, setTenure] = useState("");
  const [tenureGpa, setTenureGpa] = useState("");
  const [coverage, setCoverage] = useState("");
  const [premiumExcGST, setPremiumExcGST] = useState("");
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);

  useEffect(() => {
    const fetchPricingData = async () => {
      try {
        const response = await axios.get(
          "https://flashaid-v3-prod-backend.flashaid.in/auth/v1/customer-insurance/tirumala/pricing-gtl"
        );
        console.log(response,"check")
        const transformedData = transformPricingData(response.data);
        setPricingData(transformedData);
        if (Object.keys(transformedData).length > 0) {
          setTenure(Object.keys(transformedData)[0]);
        }
      } catch (error) {
        console.error("Error fetching pricing data:", error);
      }
    };

    fetchPricingData();
  }, []);


  useEffect(() => {
    const fetchPricingDataGpa = async () => {
      try {
        const response = await axios.get(
          "https://flashaid-v3-prod-backend.flashaid.in/auth/v1/customer-insurance/tirumala/pricing-gpa"
        );
        console.log(response,"response data")
        const transformedData = transformPricingDataGpa(response.data);
        setPricingDataGpa(transformedData);
        if (Object.keys(transformedData).length > 0) {
          setTenureGpa(Object.keys(transformedData)[0]);
        }
      } catch (error) {
        console.error("Error fetching pricing data:", error);
      }
    };

    fetchPricingDataGpa();
  }, []);

  const transformPricingData = (data) => {
    const result = {};
    data.forEach((item) => {
      const years = item["insuranceCoverageYears"];
      delete item["insuranceCoverageYears"];
      result[years] = item;
    });
    return result;
  };

  const transformPricingDataGpa = (data) => {
    const result = {};
    data.forEach((item) => {
      const years = item["insuranceCoverageYears"];
      delete item["insuranceCoverageYears"];
      result[years] = item;
    });
    return result;
  };


  useEffect(() => {
    console.log(totalLoanAmount,tenure,"check total loan amount")
    if (totalLoanAmount) {
      const amounts = Object.keys(pricingData[tenure])
        .map(Number)
        .sort((a, b) => a - b);
      let closestAmount = amounts.find((amount) => amount >= totalLoanAmount);
      if (!closestAmount) {
        closestAmount = amounts[amounts.length - 1];
      }
      setCoverage(closestAmount);
    }
  }, [totalLoanAmount, tenure]);

  useEffect(() => {
    if (totalLoanAmount) {
      const finalPremium = calculatePremium(totalLoanAmount, tenure);
      console.log(finalPremium,"final premium")
      setFormData({
        ...formData,
        premiumIncGST: finalPremium,
      });
    }
  }, [totalLoanAmount, tenure]);

  const calculatePremium = (loanAmount, tenure) => {
    const tenureNumber = parseInt(tenure.split("_")[0], 10);
    const adjustedTenure = tenureNumber > 3 ? 3 : tenureNumber;
    const tenureKey = `${adjustedTenure}_years`;
  
    if (!pricingData[tenureKey] || !pricingDataGpa[tenureKey]) {
      return "N/A";
    }
  
    let totalPremium = 0;
  
    // Function to find the closest premium for a given amount
    const getPremiumForAmount = (amount, pricingDataSource) => {
      const amounts = Object.keys(pricingDataSource[tenureKey])
        .map(Number)
        .sort((a, b) => a - b);
      
      let closestAmount = amounts.find((amt) => amt >= amount);
      if (!closestAmount) {
        closestAmount = amounts[amounts.length - 1];
      }
  
      let basePremium = pricingDataSource[tenureKey][closestAmount];
      let amountWithoutCommas = basePremium.toString().replace(/,/g, "");
      return parseFloat(amountWithoutCommas);
    };
  
    if (loanAmount > 3000000) {
      // Split into base and excess amounts
      const baseAmount = 3000000;
      const excessAmount = loanAmount - baseAmount;
  
      // Get premium for base amount from pricingData
      const basePremium = getPremiumForAmount(baseAmount, pricingData);
      // Get premium for excess amount from pricingDataGpa
      const excessPremium = getPremiumForAmount(excessAmount, pricingDataGpa);
  
      totalPremium = basePremium + excessPremium;
    } else {
      // Use pricingData if loanAmount is 3,000,000 or less
      totalPremium = getPremiumForAmount(loanAmount, pricingData);
    }
  
    // Set premium excluding GST
    setPremiumExcGST(totalPremium);
  
    // Calculate final premium including GST
    const premiumWithTax = (totalPremium + totalPremium * 0.18).toFixed(3);
    return Math.ceil(premiumWithTax);
  };
  

  const [formData, setFormData] = useState({
    aadharFrontPage: null,
    aadharBackPage: null,
    panImage: null,
    longQuestionnaire: null,
    customerId: "",
    dateOfBirth: "",
    // age: "",
    firstname: "",
    lastname: "",
    gender: "",
    address: "",
    pincode: "",
    mobileNumber: "",
    emailId: "",
    aadhar: "",
    pan: "",
    nomineeName: "",
    nomineeRelation: "",
    nomineeAadharNo: "",
    nomineePanNo: "",
    nomineeDob:"",
    // nomineeAge:"",
    state: "",
    occupation: "",
    premiumIncGST: "",
  });
  const requiredFields = [
    "customerId",
    "firstname",
    "lastname",
    "dateOfBirth",
    "nomineeDob",
    // "nomineeAge",
    "age",
    "gender",
    "address",
    "pincode",
    "mobileNumber",
    "emailId",
    "state",
  ];

  const isCustomerIdValid = () => formData.customerId.trim() !== "";
  const isFirstNameValid = () => formData.firstname.trim() !== "";
  const isLastNameValid = () => formData.lastname.trim() !== "";
  const isDobValid = () => formData.dateOfBirth !== "";
  const isAgeValid = () => formData.age !== "";
  const isGenderValid = () => formData.gender.trim() !== "";
  const isAddressValid = () => formData.address.trim() !== "";
  const isPincodeValid = () => validatePincode(formData.pincode);
  const isMobileNumberValid = () => validatePhoneNumber(formData.mobileNumber);
  const isEmailIdValid = () => validateEmail(formData.emailId);
  const isStateValid = () => formData.state.trim() !== "";
  const isAadharValid =  () => formData.aadhar.trim() !== "";
  const isPanValid = () => formData.pan.trim() !== "";
  const isNomineeNameValid = () => formData.nomineeName.trim() !== "";
  const isNomineeRelationValid = () => formData.nomineeRelation.trim() !== "";
    const isNomineeDOBValid = () => formData.nomineeDob.trim() !== "";
    const isNomineeAadharValid = () => formData.nomineeAadharNo.trim() !== "";
    const isNomineePanValid = () => formData.nomineePanNo.trim() !== "";
    const isOccupationValid = () => formData.occupation.trim() !== "";
    // const isLoanAmountValid = () => entry.loanAmount.trim() !== "";
    // const isLoanSanctionDateValid = () => entry.loanSanctionDate.trim() !== "";
    //   const isLoanEndDateValid = () => entry.loanEndDate.trim() !== "";
    //     const isLoanTypeValid = () => entry.loanType.trim() !== "";
    //       const isLenderBranchValid = () => entry.lenderBranch.trim() !== "";
    //         const isLoanAccountNumberValid = () => entry.loanAccountNumber.trim() !== "";
    const isLoanAmountValid = () =>
      loanDetails.every((entry) => entry.loanAmount.trim() !== "");
    
    const isLoanSanctionDateValid = () =>
      loanDetails.every((entry) => entry.loanSanctionDate.trim() !== "");
    
    const isLoanEndDateValid = () =>
      loanDetails.every((entry) => entry.loanEndDate.trim() !== "");
    
    const isLoanTypeValid = () =>
      loanDetails.every((entry) => entry.loanType.trim() !== "");
    
    const isLenderBranchValid = () =>
      loanDetails.every((entry) => entry.lenderBranch.trim() !== "");
    
    const isLoanAccountNumberValid = () =>
      loanDetails.every((entry) => entry.loanAccountNumber.trim() !== "");
    
// const tenureYears = React.useMemo(() => {
//   if (!tenure) return 0;
//   const n = parseInt(String(tenure).split("_")[0], 10);
//   return Number.isFinite(n) ? n : 0;
// }, [tenure]);

// useEffect(() => {
//   setShowPopup(tenureYears >= 3);
// }, [tenureYears]);

    

 
    // Manual Form Validation
    const isLongQuesValid = () => formData.longQuestionnaire  !== "";
    const isMemberQuesValid = () => formData.membership !== "";
  
    // Digital Verification Validation
    const isMedicalHistoryValid = () => responses.medicalHistory !== "";
    const isInsuranceHistoryValid = () => responses.insuranceHistory.trim() !== "";
    const isCovidHistoryValid = () => responses.covidHistory.trim() !== "";
    const isHazardousActivitiesValid = () => responses.hazardousActivities.trim() !== "";



    const areRequiredFieldsFilled = () => {
      const hasImageErrors = Object.values(imageErrors).some((error) => error !== "");
    
      return (
        isCustomerIdValid() &&
        isFirstNameValid() &&
        isLastNameValid() &&
        isDobValid() &&
        isAgeValid() &&
        isGenderValid() &&
        isAddressValid() &&
        isPincodeValid() &&
        isMobileNumberValid() &&
        isEmailIdValid() &&
        isStateValid() &&
        !ageLimitExceed &&
        !hasImageErrors
        
    
       
      );
    };

    const areLoanDetailsFieldsFilled = () => {
     const aadharIsValid =  isAadharValid();
     const panIsValid = isPanValid();
     const nomineeNameIsValid = isNomineeNameValid();
     const nomineeRelationIsValid = isNomineeRelationValid();
     const nomineeDobIsValid = isNomineeDOBValid();
     const nomineeAadharIsValid = isNomineeAadharValid();
     const nomineePanIsValid = isNomineePanValid();
     const nomineeOccupationIsValid = isOccupationValid();
     const loanAmountIsValid = isLoanAmountValid();
     const loanSanctionDateIsValid = isLoanSanctionDateValid();
     const loanEndDateIsValid = isLoanEndDateValid();
     const loanTypeIsValid = isLoanTypeValid();
     const lenderBranchIsValid = isLenderBranchValid();
     const loanAccountNumberIsValid = isLoanAccountNumberValid();

     console.log(aadharIsValid,"chek aadhar")
      // const loanDetailsValid = isLoanDetailsValid();
    
      // console.log("Loan Details Valid:", loanDetailsValid);
      // console.log("Function Result:", loanDetailsValid );
    
      return (
        aadharIsValid &&
        panIsValid &&
        nomineeNameIsValid &&
        nomineeDobIsValid &&
        nomineeRelationIsValid &&
        nomineeAadharIsValid &&
        nomineePanIsValid &&
        nomineeOccupationIsValid &&
        loanAmountIsValid &&
        loanSanctionDateIsValid &&
        loanEndDateIsValid &&
        loanTypeIsValid &&
        lenderBranchIsValid &&
        loanAccountNumberIsValid
      );
    };
    


    const areRequiredFieldsFilledForHealQuestionButton = () => {
      const hasImageErrors = Object.values(imageErrors).some((error) => error !== "");
    
      return (
        (isManual ? isLongQuesValid()  &&  isMemberQuesValid : 
        (isMedicalHistoryValid() &&
        isInsuranceHistoryValid() &&
        isCovidHistoryValid() &&
        isHazardousActivitiesValid()))
        // isCustomerIdValid() &&
        // isFirstNameValid() &&
        // isLastNameValid() &&
        // isDobValid() &&
        // isAgeValid() &&
        // isGenderValid() &&
        // isAddressValid() &&
        // isPincodeValid() &&
        // isMobileNumberValid() &&
        // isEmailIdValid() &&
        // isStateValid() &&
        // !ageLimitExceed &&
        // !hasImageErrors
      );
    };

  const [imagePreviews, setImagePreviews] = useState({
    aadharFrontPage: null,
    aadharBackPage: null,
    panImage: null,
    longQuestionnaire:null,
    membership:null,
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [errors, setErrors] = useState({});

  // useEffect(() => {
  //   if (manualForm) {
  //     // If Manual Form is selected, check if a file is uploaded
  //     setIsSaveDisabled(!imagePreviews.longQuestionnaire);
  //     setIsSaveDisabled(!imagePreviews.membership)
  //   } else if (digitalVerify) {
  //     // If Digital Verification is selected, check if all answers are selected
  //     const allAnswered = Object.values(responses).every((value) => value === "yes" || value === "no");
  //     setIsSaveDisabled(!allAnswered);
  //   }
  // }, [manualForm, digitalVerify, responses, imagePreviews]);

  useEffect(() => {
    if (isManual) {
      // If Manual Form is selected, check if a file is uploaded
      setIsSaveDisabled(!imagePreviews.longQuestionnaire);
      setIsSaveDisabled(!imagePreviews.membership)
    } else if (isDigital) {
      // If Digital Verification is selected, check if all answers are selected
      const allAnswered = Object.values(responses).every((value) => value === "yes" || value === "no");
      setIsSaveDisabled(!allAnswered);
    }
  }, [isManual, isDigital, responses, imagePreviews]);

  


  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "customerId") {
    // Allow only alphanumeric characters (numbers and letters from a-z)
    const regex = /^[a-zA-Z0-9]*$/;
    if (!regex.test(value)) {
      // Do nothing if the value contains invalid characters
      return;
    }
  }

  
  if (name === "mobileNumber") {
    const numericValue = value.replace(/\D/g, ""); // Ensure only numbers
    setFormData((prev) => ({
      ...prev,
      mobileNumber: numericValue,
    }));
    setPhoneNumber(numericValue); // Automatically update phoneNumber
  } 
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  useEffect(() => {
    if (!formData.dateOfBirth) return;
  
    const age = calculateAge(formData.dateOfBirth);
  
    if (age >= 65) {
      setAgeLimitExceed(true);
      // setErrors((prev) => ({
      //   ...prev,
      //   dateOfBirth: "Age cannot be more than 65.",
      // }));
    } else {
      setAgeLimitExceed(false);
      // setErrors((prev) => ({
      //   ...prev,
      //   dateOfBirth: "",
      // }));
    }
  
    
    setFormData((prev) => ({
      ...prev,
      age,
    }));
  }, [formData.dateOfBirth]);
  

  const handleDobChange = (e) => {
    const dateOfBirth = e.target.value;
    const age = calculateAge(dateOfBirth);
    console.log("DOB:", dateOfBirth, "Age:", age);
    // let newErrors = { ...errors };
    // if (age > 65) {
      
    //   setAgeLimitExceed(true);
    //   // setErrors((prev) => ({
    //   //   ...prev,
    //   //   dateOfBirth: "Age cannot be more than 65.",
    //   // }));
    //   // newErrors.dateOfBirth = "Age cannot be more than 65.";
    // } else {
      
    //   setAgeLimitExceed(false);
    //   // newErrors.dateOfBirth = "";
    //   // setErrors((prev) => ({
    //   //   ...prev,
    //   //   dateOfBirth: "",
    //   // }));
    // }
    setFormData({
      ...formData,
      dateOfBirth,
      age,
    });
  };
  const handleNomineeDobChange = (e) => {
    const nomineeDob = e.target.value;
    const nomineeAge = calculateAge(new Date(nomineeDob));
    setFormData({
      ...formData,
      nomineeDob,
      // nomineeAge,
    });
  };



  const calculateAge = (dateOfBirth) => {
    const today = new Date();
    const birthDate = new Date(dateOfBirth);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  };
  const calculateExpiryDate = (tenure) => {
    const currentDate = new Date(); // Get the current date
    currentDate.setFullYear(currentDate.getFullYear() + parseInt(tenure)); // Add tenure years
    const year = String(currentDate.getFullYear()); // Get the last two digits of the year (YY)
    const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed, so +1, and pad single digit months
    const day = String(currentDate.getDate()).padStart(2, "0"); // Pad single digit days

    return `${year}-${month}-${day}`; // Format as "YY/MM/DD"
  };
  const calculateIssueDate = () => {
    const currentDate = new Date(); // Get the current date
    currentDate.setFullYear(currentDate.getFullYear());
    const year = String(currentDate.getFullYear()); // Get the last two digits of the year (YY)
    const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed, so +1, and pad single digit months
    const day = String(currentDate.getDate()).padStart(2, "0"); // Pad single digit days

    return `${year}-${month}-${day}`; // Format as "YY/MM/DD"
  };

  const validateForm = () => {
    const newErrors = {};

    // Check for empty fields
    Object.keys(formData).forEach((key) => {
      if (formData[key] === "" && key !== "nomineePanNo") {
        newErrors[key] = "This field is required";
      }
    });

    // Additional specific checks
    if (formData.mobileNumber && !validatePhoneNumber(formData.mobileNumber)) {
      newErrors.mobileNumber = "Invalid Mobile Number";
    }
    if (formData.emailId && !validateEmail(formData.emailId)) {
      newErrors.emailId = "Invalid Email Address";
    }
    if (formData.pincode && !validatePincode(formData.pincode)) {
      newErrors.pincode = "Invalid Pincode";
    }
    if (formData.aadhar && !validateAadhaar(formData.aadhar)) {
      newErrors.aadhar = "Invalid Aadhaar Number";
    }
    if (
      formData.nomineeAadharNo &&
      !validateAadhaar(formData.nomineeAadharNo)
    ) {
      newErrors.nomineeAadharNo = "Invalid Aadhaar Number";
    }
    // if (formData.nomineePanNo && !validatePAN(formData.nomineePanNo)) {
    //   newErrors.nomineePanNo = 'Invalid PAN Number';
    // }
    if (formData.pan && !validatePAN(formData.pan)) {
      newErrors.pan = "Invalid PAN Number";
    }

    //loan-errors
    loanDetails.forEach((entry, index) => {
      if (!entry.loanAmount) {
        newErrors[`loanAmount_${index}`] = "Loan Amount is required";
      }
      if (!entry.loanSanctionDate) {
        newErrors[`loanSanctionDate_${index}`] =
          "Loan Sanction Date is required";
      }
      if (!entry.loanAccountNumber) {
        newErrors[`loanAccountNumber_${index}`] =
          "Loan Account Number is required";
      }

      if (!entry.loanEndDate) {
        newErrors[`loanEndDate_${index}`] = "Loan End Date is required";
      }
      if (!entry.loanType) {
        newErrors[`loanType_${index}`] = "Loan Type is required";
      }
      if (!entry.lenderBranch) {
        newErrors[`lenderBranch_${index}`] = "Lender Branch is required";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  
  
  const handleSubmit = async (e) => {
    e.preventDefault();



  // if (!validateForm()) {
  //   return; // Don't proceed if form has errors
  // }

  // if (!loanDetails || loanDetails.length === 0) {
  //   alert("Loan details are required to generate FAID.");
  //   return;
  // }

  // Optionally: Validate loan detail structure
  // const isValidLoan = loanDetails.every(
  //   (entry) =>
  //     entry.loanAmount &&
  //     entry.loanSanctionDate &&
  //     entry.loanAccountNumber &&
  //     entry.loanEndDate &&
  //     entry.loanType &&
  //     entry.lenderBranch
  // );

  // if (!isValidLoan) {
  //   alert("Please fill all required loan details.");
  //   return;
  // }

    const transformedTenure = tenure.split("_")[0];
    const fullname = `${formData.firstname} ${formData.lastname}`;
    const expiryDate = calculateExpiryDate(transformedTenure);
    const issueDate = calculateIssueDate();
    const updatedTenure = Number(transformedTenure);

    const {
      aadharFrontPage,
      aadharBackPage,
      panImage,
      longQuestionnaire,
      membership,
      customerId,
      age,
      // nomineeAge,
      state,
      ...formDataWithoutFiles
    } = formData;
    const formDataToSend = {
      ...formDataWithoutFiles,
      partnerId: 24,
      tenure: updatedTenure,
      loanDetails,
      totalLoanAmount,
      fullname,
      expiryDate,
      issueDate,
      gpaCoverage: 0,
      gmcCoverage: 0,
      txnDate: "",
      insuranceCompanyNames: totalLoanAmount > 3000000 ? ["aviva", "universal"] : ["aviva"],
      tpaNames: totalLoanAmount > 3000000 ? ["aviva", "universal"] : ["aviva"],
      otherInsured: [],
      certificate: [],
      uhid: [],
      hasAnyYesAnswer,
      isDigital,
      isManual,
      longQuestionnaireUrl: null,
      membershipUrl: null,
      totalNoOfLives: 1,
      adult: 1,
      child: 1,
      masterPolicyNumber: "",
      source: "form",
      gtlCoverage:0,
      aadharFrontPage: "aadhar_front_image",
      aadharBackPage:"aadhar_back_image",
      panImage: "pan_image",
      mcq: [
        responses
      ],
      age:Number(formData.age),
      employeeId: formData.customerId,
      customerId: Number(formData.customerId),
      premiumExcGST:Number(premiumExcGST),
    };
    try {
      const formPayload = new FormData();
      formPayload.append("customerInsurance", JSON.stringify(formDataToSend));
  
      formPayload.append("aadharFrontPage",formData.aadharFrontPage ? formData.aadharFrontPage : "");
      formPayload.append("aadharBackPage", formData.aadharBackPage ? formData.aadharBackPage : "");
      formPayload.append("panImage",formData.panImage ? formData.panImage : "");
      formPayload.append("longQuestionnaire",formData.longQuestionnaire ? formData.longQuestionnaire : "");
      formPayload.append("membership",formData.membership ? formData.membership : "");

  
      const url = "https://flashaid-v3-prod-backend.flashaid.in/auth/v1/customer-insurance/tirumala/single-upload";
     
      const response = await axios.post(url, formPayload);
      setPopupResponse(response);
      setDataIsSent(true);
      setLoading(false);
      setFormData({
        aadharFrontPage: null,
        aadharBackPage: null,
        panImage: null,
        longQuestionnaire:null,
        membership:null,
        customerId: "",
        dateOfBirth: "",
        age: "",
        firstname: "",
        lastname: "",
        gender: "",
        address: "",
        pincode: "",
        mobileNumber: "",
        emailId: "",
        aadhar: "",
        pan: "",
        nomineeDob: "",
        // nomineeAge: "",
        nomineeName: "",
        nomineeRelation: "",
        nomineeAadharNo: "",
        nomineePanNo: "",
        state: "",
        occupation: "",
        premiumIncGST: "",
      });
      setLoanEntries([
        {
          loanAmount: "",
          loanSanctionDate: "",
          loanEndDate: "",
          loanType: "",
          lenderBranch: "",
          loanAccountNumber: "",
        },
      ]);
      setCurrentPage(1);
      setCvgSum("");
      setCoverage("");
      setPremiumExcGST("");
      setImagePreviews({
        aadharFrontPage: null,
        aadharBackPage: null,
        panImage: null,
        longQuestionnaire:null,
        membership:null,
      });
      setManualForm(false)
      setDigitalVerify(false)
      setOtpVerified(false)
      setResponses({
        medicalHistory: "",
        insuranceHistory: "",
        covidHistory: "",
        hazardousActivities: "",
      })
      setPhoneNumber("")
      setSingleManualForm(false)
      setOtp("")
      setOtpSent("")
      setServerOtp("")
      setMemberForm(false);
      setIsManual(false);
      setIsDigital(false);
      setHasAnyYesAnswer(false);
      setTotalLoanAmount(0);
    } catch (error) {
      // setErrorResponse(error.response.data.data.message);
      console.error("Error:", error, "new error");
      setDataIsNotSent(true);
      setLoading(false);
      setTimeout(() => {
        setDataIsNotSent(false);
      }, 2000);
    }
  };
  const validateAadhaar = (aadhaar) => {
    const expr =
      /^([0-9]{4}[0-9]{4}[0-9]{4}$)|([0-9]{4}\s[0-9]{4}\s[0-9]{4}$)|([0-9]{4}-[0-9]{4}-[0-9]{4}$)/;
    return expr.test(aadhaar);
  };
  const validatePAN = (pan) => {
    const regex = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;
    return regex.test(pan.toUpperCase());
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    const file = files[0];

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreviews({
          ...imagePreviews,
          [name]: reader.result,
        });
      };
      reader.readAsDataURL(file);
    }

    setFormData({
      ...formData,
      [name]: file,
    });
  };

  const handleRemoveImage = (name) => {
    setImagePreviews({
      ...imagePreviews,
      [name]: null,
    });
    setFormData({
      ...formData,
      [name]: null,
    });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleDeleteLoan = (index) => {
    // Create a new array excluding the loan entry at the specified index
    const updatedEntries = loanDetails.filter((_, i) => i !== index);
    // Update the state with the new array
    setLoanEntries(updatedEntries);
    const newTotalLoanAmount = updatedEntries.reduce((total, entry) => {
      // Convert to number or default to 0 if invalid
      const loanAmount = parseFloat(entry.loanAmount) || 0;
      return total + loanAmount;
    }, 0);

    // Update the total loan amount state
    setTotalLoanAmount(newTotalLoanAmount);
  };

  const MAX_FILE_SIZE = 1024 * 1024; // 1 MB in bytes

  /**
   * Function to check if a file's size is within the allowed limit.
   * @param {File} file - The file to be checked.
   * @returns {boolean} - Returns true if valid, false otherwise.
   */
  const checkFileSize = (file) => {
    return file.size <= MAX_FILE_SIZE;
  };
const [imageErrors, setImageErrors] = useState({
  aadharFrontPage: "",
  aadharBackPage: "",
    panImage: "",
    longQuestionnaire:"",
    membership:"",
  });

  //const anyYesResponse = Object.values(responses).includes("yes");

  // const isHealthFormValid =
  // (digitalVerify &&
  //   otpVerified &&
  //   Object.values(responses).every((val) => val) &&
  //   (Boolean(imagePreviews.longQuestionnaire)) || // Ensure file upload is required only when needed
  //   (Object.values(responses).some((val) => val === "yes") && Boolean(imagePreviews.longQuestionnaire)) // New condition: If any response is "yes", longQues must be provided
  // ) ||
  // (manualForm &&  Boolean(imagePreviews.membership)) || Object.values(responses).every((val) => val === "no");

  const isHealthFormValid =
  (isDigital &&
    otpVerified &&
    Object.values(responses).every((val) => val) &&
    (Boolean(imagePreviews.longQuestionnaire)) || // Ensure file upload is required only when needed
    (Object.values(responses).some((val) => val === "yes") && Boolean(imagePreviews.longQuestionnaire)) // New condition: If any response is "yes", longQues must be provided
  ) ||
  (isManual &&  Boolean(imagePreviews.membership)) || Object.values(responses).every((val) => val === "no");






  useEffect(() => {
    const fieldsToValidate = ["aadharFrontPage", "aadharBackPage", "panImage", "longQuestionnaire","membership"];
    fieldsToValidate.forEach((field) => {
      const file = formData[field];
      if (file) {
        if (!checkFileSize(file)) {
          setImageErrors((prev) => ({
            ...prev,
            [field]: `${field.replace(/([A-Z])/g, " $1")} exceeds 1 Mb. Please upload a smaller file.`,
          }));
        } else {
          setImageErrors((prev) => ({
            ...prev,
            [field]: "",
          }));
        }
      }
    });
  }, [formData]);


  return (
    <>
      {loading ? (
        <ClipLoader
          className="clip-loader"
          color="black"
          loading={loading}
          cssOverride={override}
          size={70}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      ) : (
        <>
          {dataIsSent && popupResponse && (
            <SuccessModal
              popupResponse={popupResponse}
              message="Data submitted successfully!"
              onClose={handleSuccessClose}
            />
          )}
          {dataIsNotSent && (
            <ErrorModal
              ErrorResponse={ErrorResponse}
              isOpen={dataIsNotSent}
              message="An error occurred. Please try again."
              onClose={handleErrorClose}
            />
          )}
          <div className="tirumala-dc-form" id="data-form">
            <img
              className="tirumala-page-image"
              src="https://storage.googleapis.com/flash-v2/assets/images/logo.png"
              alt="tirumala Logo"
            />
            <form className={`data-form-main`} onSubmit={handleSubmit}>
              {currentPage === 1 && (
                <div className="first-part">
                  <label>
                    Customer ID:
                    <input
                      type="text"
                      name="customerId"
                      value={formData.customerId}
                      onChange={handleChange}
                    />
                    {errors.customerId && (
                      <span className="error">{errors.customerId}</span>
                    )}
                  </label>
                  <label>
                    First Name:
                    <input
                      type="text"
                      name="firstname"
                      value={formData.firstname}
                      onChange={handleChange}
                    />
                    {errors.firstname && (
                      <span className="error">{errors.firstname}</span>
                    )}
                  </label>
                  <label>
                    Last Name:
                    <input
                      type="text"
                      name="lastname"
                      value={formData.lastname}
                      onChange={handleChange}
                    />
                    {errors.lastname && (
                      <span className="error">{errors.lastname}</span>
                    )}
                  </label>
                  <label>
                    DOB (DD-MM-YYYY):
                    <input
                      type="date"
                      name="dateOfBirth"
                      value={formData.dateOfBirth}
                      onChange={handleDobChange}
                    />
                    {errors.dateOfBirth && <span className="error">{errors.dateOfBirth}</span>}
                  </label>
                  <label>
                    Age:
                    <input
                      type="text"
                      name="age"
                      value={formData.age}
                      readOnly
                    />
                    {errors.age && <span className="error">{errors.age}</span>}
                    {ageLimitExceed && (
                      <span className="error">Max age allowed is 65</span>
                    )}
                  </label>
                  <label>
                    Gender:
                    <select
                      name="gender"
                      value={formData.gender}
                      onChange={handleChange}
                    >
                      <option value="">Select Gender</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                    </select>
                    {errors.gender && (
                      <span className="error">{errors.gender}</span>
                    )}
                  </label>
                  <label>
                    Address:
                    <input
                      type="text"
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                    />
                    {errors.address && (
                      <span className="error">{errors.address}</span>
                    )}
                  </label>
                  <label>
                    Pincode:
                    <input
                      type="number"
                      name="pincode"
                      value={formData.pincode}
                      onChange={handleChange}
                    />
                    {errors.pincode && (
                      <span className="error">{errors.pincode}</span>
                    )}
                  </label>
                  <label>
                    State:
                    <input
                      type="text"
                      name="state"
                      value={formData.state}
                      onChange={handleChange}
                    />
                    {errors.state && (
                      <span className="error">{errors.state}</span>
                    )}
                  </label>
                  <label>
                    Mobile Number:
                    <input
                      type="number"
                      name="mobileNumber"
                      value={formData.mobileNumber}
                      onChange={handleChange}
                    />
                    {errors.mobileNumber && (
                      <span className="error">{errors.mobileNumber}</span>
                    )}
                  </label>
                  <label>
                    Email Id:
                    <input
                      type="email"
                      name="emailId"
                      value={formData.emailId}
                      onChange={handleChange}
                    />
                    {errors.emailId && (
                      <span className="error">{errors.emailId}</span>
                    )}
                  </label>
                  <label>
                    Aadhar front Image (Optional):
                    <input
                      type="file"
                      name="aadharFrontPage"
                      accept="image/*"
                      onChange={handleFileChange}
                    />
                    {imagePreviews.aadharFrontPage && (
                      <div className="image-preview">
                        <img
                          src={imagePreviews.aadharFrontPage}
                          alt="Aadhar Card"
                        />
                        <p>Image uploaded</p>
                        <button
                          type="button"
                          onClick={() => handleRemoveImage("aadharFrontPage")}
                        >
                          Change Image
                        </button>
                      </div>
                    )}
                      {imageErrors.aadharFrontPage && (
                      <span className="error">{imageErrors.aadharFrontPage}</span>
                    )}
                  </label>
                  <label>
                    Aadhar Back Image (Optional):
                    <input
                      type="file"
                      name="aadharBackPage"
                      accept="image/*"
                      onChange={handleFileChange}
                    />
                    {imagePreviews.aadharBackPage && (
                      <div className="image-preview">
                        <img src={imagePreviews.aadharBackPage} alt="Aadhar Card" />
                        <p>Image uploaded</p>
                        <button
                          type="button"
                          onClick={() => handleRemoveImage("aadharBackPage")}
                        >
                          Change Image
                        </button>
                      </div>
                    )}
                    {imageErrors.aadharBackPage && (
                      <span className="error">{imageErrors.aadharBackPage}</span>
                    )}
                  </label>
                  <label>
                    PAN Card Image (Optional):
                    <input
                      type="file"
                      name="panImage"
                      accept="image/*"
                      onChange={handleFileChange}
                    />
                    {imagePreviews.panImage && (
                      <div className="image-preview">
                        <img src={imagePreviews.panImage} alt="PAN Card" />
                        <p>Image uploaded</p>
                        <button
                          type="button"
                          onClick={() => handleRemoveImage("panImage")}
                        >
                          Change Image
                        </button>
                      </div>
                    )}
                    {imageErrors.panImage && (
                      <span className="error">{imageErrors.panImage}</span>
                    )}
                  </label>

   
    <br />
                </div>
              )}

              {currentPage === 2 && (
                <div className="second-part">
                  <label>
                    Member Aadhar No.:
                    <input
                      type="number"
                      name="aadhar"
                      value={formData.aadhar}
                      onChange={handleChange}
                    />
                    {errors.aadhar && (
                      <span className="error">{errors.aadhar}</span>
                    )}
                  </label>
                  <label>
                    Member PAN Card:
                    <input
                      type="text"
                      name="pan"
                      value={formData.pan}
                      onChange={handleChange}
                    />
                    {errors.pan && (
                      <span className="error">{errors.pan}</span>
                    )}
                  </label>

                  <label>
                    Nominee Details Name:
                    <input
                      type="text"
                      name="nomineeName"
                      value={formData.nomineeName}
                      onChange={handleChange}
                    />
                    {errors.nomineeName && (
                      <span className="error">{errors.nomineeNamec}</span>
                    )}
                  </label>
                  <label>
                    Nominee Relationship:
                    <select
                      name="nomineeRelation"
                      value={formData.nomineeRelation}
                      onChange={handleChange} // Correctly pass e and index
                    >
                      <option value="">Select Relationship</option>
                      <option value="son">Son</option>
                      <option value="daughter">Daughter</option>
                      <option value="father">Father</option>
                      <option value="mother">Mother</option>
                      <option value="spouse">Spouse</option>
                      <option value="brother">Brother</option>
                      <option value="sister">Sister</option>
                    </select>
                    {errors.nomineeRelation && (
                      <span className="error">
                        {errors.nomineeRelation}
                      </span>
                    )}
                  </label>
                  <label>
                    Nominee DOB (DD-MM-YYYY):
                    <input
                      type="date"
                      name="nomineeDob"
                      value={formData.nomineeDob}
                      onChange={handleNomineeDobChange}
                    />
                    {errors.nomineeDob && <span className="error">{errors.nomineeDob}</span>}
                  </label>
                  {/* <label>
                   Nominee Age:
                    <input
                      type="text"
                      name="nomineeAge"
                      value={formData.nomineeAge}
                      readOnly
                    />
                    {errors.nomineeAge && <span className="error">{errors.nomineeAge}</span>}
                  </label> */}
                  <label>
                    Nominee Aadhar No.:
                    <input
                      type="number"
                      name="nomineeAadharNo"
                      value={formData.nomineeAadharNo}
                      onChange={handleChange}
                    />
                    {errors.nomineeAadharNo && (
                      <span className="error">{errors.nomineeAadharNo}</span>
                    )}
                  </label>
                  <label>
                    Nominee Pan No.:
                    <input
                      type="text"
                      name="nomineePanNo"
                      value={formData.nomineePanNo}
                      onChange={handleChange}
                    />
                    {errors.nomineePanNo && (
                      <span className="error">{errors.nomineePanNo}</span>
                    )}
                  </label>
                  <label>
                    Member Occupation:
                    <input
                      type="text"
                      name="occupation"
                      value={formData.occupation}
                      onChange={handleChange}
                    />
                    {errors.occupation && (
                      <span className="error">{errors.occupation}</span>
                    )}
                  </label>
                  <div className="loan-amount-section">
                    {loanDetails &&
                      loanDetails.map((entry, index) => (
                        <div key={index} className="loan-amount-section-first">
                          <label>
                            Loan Amount:
                            <input
                              type="text"
                              name={`loanAmount_${index}`}
                              value={entry.loanAmount}
                              onChange={(e) => handleLoanChange(e, index)} // Correctly pass e and index
                            />
                            {errors[`loanAmount_${index}`] && (
                              <span className="error">
                                {errors[`loanAmount_${index}`]}
                              </span>
                            )}
                          </label>
                          <label>
                            Loan Sanction Date:
                            <input
                              type="date"
                              name={`loanSanctionDate_${index}`}
                              value={entry.loanSanctionDate}
                              onChange={(e) => handleLoanChange(e, index)} // Correctly pass e and index
                            />
                            {errors[`loanSanctionDate_${index}`] && (
                              <span className="error">
                                {errors[`loanSanctionDate_${index}`]}
                              </span>
                            )}
                          </label>
                          <label>
                            Loan End Date:
                            <input
                              type="date"
                              name={`loanEndDate_${index}`}
                              value={entry.loanEndDate}
                              onChange={(e) => handleLoanChange(e, index)} // Correctly pass e and index
                            />
                            {errors[`loanEndDate_${index}`] && (
                              <span className="error">
                                {errors[`loanEndDate_${index}`]}
                              </span>
                            )}
                          </label>
                          <label>
                            Loan Type:
                            <select
                              name={`loanType_${index}`}
                              value={entry.loanType}
                              onChange={(e) => handleLoanChange(e, index)} // Correctly pass e and index
                            >
                              <option value="">Select Loan Type</option>
                              <option value="Personal">Personal</option>
                              <option value="LAP">LAP</option>
                              <option value="Vehicle">Vehicle</option>
                              <option value="HomeLoan">Home Loan</option>
                              <option value="Others">Others</option>
                              <option value="deposit loan">Deposit Loan</option>
                              <option value="daily deposits loan">
                                Daily Deposits loan
                              </option>
                            </select>
                            {errors[`loanType_${index}`] && (
                              <span className="error">
                                {errors[`loanType_${index}`]}
                              </span>
                            )}
                          </label>
                          <label>
                            Lender Branch:
                            <select
                              name={`lenderBranch_${index}`}
                              value={entry.lenderBranch}
                              onChange={(e) => handleLoanChange(e, index)}
                            >
                              <option value="">Select Lender Branch</option>
                              {branchList.map((branch, i) => (
                                <option key={i} value={branch}>
                                  {branch}
                                </option>
                              ))}
                            </select>
                            {errors[`lenderBranch_${index}`] && (
                              <span className="error">
                                {errors[`lenderBranch_${index}`]}
                              </span>
                            )}
                          </label>
                          <label>
                            Loan Account Number:
                            <input
                              type="text"
                              name={`loanAccountNumber_${index}`}
                              value={entry.loanAccountNumber}
                              onChange={(e) => handleLoanChange(e, index)} // Correctly pass e and index
                            />
                            {errors[`loanAccountNumber_${index}`] && (
                              <span className="error">
                                {errors[`loanAccountNumber_${index}`]}
                              </span>
                            )}
                          </label>
                          {index > 0 && (
                            <button
                              type="button"
                              className="
      delete-loan"
                              onClick={() => handleDeleteLoan(index)}
                            >
                              Delete
                            </button>
                          )}
                        </div>
                      ))}
                    <div className="loan-amount-section-second">
                      <button onClick={addMoreLoans}>
                        Add More Loan Amounts
                      </button>
                    </div>
                    <span className="total-loan-amount">
                      Total loan amount : {totalLoanAmount}
                    </span>
                  </div>

                  {/* <label>
              Policy Sum Insured:
              <input
              disabled
                type="number"
                name="cvgSum"
                value={coverage}
              />
            </label> */}
                  <label>
  
  <span className="label-text">
        Policy Tenure:
      </span>
  <select
    value={tenure}
    onChange={(e) => 
      {const value = e.target.value;
      setTenure(value);
      const years = parseInt(value.split("_")[0], 10);
      if (years >= 3) {
        setShowPopup(true);
      } else {
        setShowPopup(false);
      }
    }}
  >
    {Object.keys(pricingData).map((key) => (
      <option key={key} value={key}>
        {key.replace(/_/g, " ")}
      </option>
    ))}
  </select>
</label>



                  <label>
                    Policy Premium Inc GST:
                    <input
                      type="text"
                      name="premiumIncGST"
                      value={formData.premiumIncGST}
                      onChange={handleChange}
                      disabled={true}
                    />
                    {errors.premiumIncGST && (
                      <span className="error">{errors.premiumIncGST}</span>
                    )}
                  </label>

                  {showPopup && (
  <div className="popup-overlay" onClick={togglePopup}>
    <div className="popup-content" onClick={(e)=>e.stopPropagation()}>
      <button className="close-button" onClick={togglePopup}>×</button>
      <p>
         The premium amount displayed corresponds to a tenure of 3 years only. After 3 years, the policy will be renewed for the remaining years in a 3-year cycle.
      </p>
      <p>
         प्रदर्शित प्रीमियम रक्कम फक्त ३ वर्षांच्या कालावधीसाठी आहे. ३ वर्षांनंतर, उर्वरित वर्षांसाठी पॉलिसी ३ वर्षांच्या कालावधीमध्ये नूतनीकरण केली जाईल.
      </p>
    </div>
  </div>
)}


                  <div>
     {totalLoanAmount > 200000 && <button
      //  className={
      //   areRequiredFieldsFilledForHealQuestionButton() ? "" : "grey-button-next"
      // }
      type="button"
      // disabled={!areRequiredFieldsFilledForHealQuestionButton()}
       onClick={() => setOpen(true)} style={styles.openButton}>
        Digital DOGH Form
      </button>}

      {open && (
        <div style={styles.dialogOverlay}>
          <div style={styles.dialog}>
            <h2 style={styles.dialogTitle}>Health Questionnaire</h2>
          
            {/* Selection for Form Type */}
            {/* <div style={styles.formSelection}>
              <button type="button" onClick={() => setManualForm(true)} style={styles.button}>
                Manual Form
              </button>
              <button
              type="button"
                onClick={() => {
                  setDigitalVerify(true);
                  setManualForm(false);
                }}
                style={styles.button}
              >
                Digital Verification
              </button>
            </div> */}

               {/* Selection for Form Type */}
               <div style={styles.formSelection}>
              <button type="button" onClick={() => setIsManual(true)} style={styles.button}>
                Manual Form
              </button>
              <button
              type="button"
                onClick={() => {
                  setIsDigital(true);
                  setIsManual(false);
                }}
                style={styles.button}
              >
                Digital Verification
              </button>
            </div>

            {/* Manual Form PDF Download */}
            {isManual && !singleManualForm && (
  <div style={styles.pdfSection}>
    <p>
      <strong>Instructions to fill out the manual forms:</strong>
    </p>
    <p>
      <strong>Step 1:</strong> Fill out the membership form first, which comprises 4 questions in the Declaration of Good Health (DOGH).
    </p>
    <p>
      <strong>Step 2:</strong>
    </p>
    <p>
      <strong>A.</strong> If you mark "No" to all 4 questions, submit only the membership form.
    </p>
    <p>
      <strong>B.</strong> If you mark "Yes" to one or more questions in the Declaration of Good Health (DOGH) of the membership form, it will be mandatory to attach the Medical Questionnaire (Long Form).
    </p>

    <p>
      <strong>फॉर्म भरण्याच्या सूचना:</strong>
    </p>
    <p>
      <strong>चरण १:</strong> कृपया सर्वप्रथम सदस्यत्व फॉर्म (membership form) भरा, ज्यामध्ये आरोग्याच्या घोषणापत्रात ४ प्रश्नांचा समावेश आहे.
    </p>
    <p>
      <strong>चरण २:</strong>
    </p>
    <p>
      <strong>अ.</strong> जर तुम्ही सर्व ४ प्रश्नांना "नाही" असे चिन्हांकित केले असेल, तर केवळ सदस्यत्व फॉर्म (membership form) जमा करा.
    </p>
    <p>
      <strong>ब.</strong> जर तुम्ही सदस्यत्व फॉर्मच्या (membership form) आरोग्याच्या घोषणापत्रात एक किंवा अधिक प्रश्नांना "होय" असे चिन्हांकित केले असेल, तर वैद्यकीय प्रश्नावली (लाँग फॉर्म) (Medical Questionnaire (Long Form)) संलग्न करणे बंधनकारक आहे.
    </p>

    {/* Membership form */}
    <a href={memmberShipFormLink} download style={styles.link} target="blank">
      Download Membership Question Form Here
    </a>

    <label>
      Membership Question Form:
      <input
        type="file"
        name="membership"
        accept="application/pdf"
        onChange={handleFileChange}
      />
      {imagePreviews.membership && (
        <div className="image-preview">
          <img src={imagePreviews.membership} alt="Member quest" />
          <p>File uploaded</p>
          <button
            type="button"
            onClick={() => handleRemoveImage("membership")}
          >
            Change File
          </button>
        </div>
      )}
      {imageErrors.membership && (
        <span className="error">{imageErrors.membership}</span>
      )}
    </label>

    {/* Long Question form */}
    <a href={pdfDownloadLink} download style={styles.link} target="blank">
      Download Long Question Form Here
    </a>

    <label>
      Long Question Form:
      <input
        type="file"
        name="longQuestionnaire"
        accept="application/pdf"
        onChange={handleFileChange}
      />
      {imagePreviews.longQuestionnaire && (
        <div className="image-preview">
          <img src={imagePreviews.longQuestionnaire} alt="Long quest" />
          <p>File uploaded</p>
          <button
            type="button"
            onClick={() => handleRemoveImage("longQuestionnaire")}
          >
            Change File
          </button>
        </div>
      )}
      {imageErrors.longQuestionnaire && (
        <span className="error">{imageErrors.longQuestionnaire}</span>
      )}
    </label>
  </div>
)}


                {/* Manual Form PDF Download */}
                {/* {singleManualForm && (
              <div style={styles.pdfSection}>
               <p>
              <b><i>You have selected "Yes" to one or more questions in the Declaration of Good Health (DOGH). As a result, it is mandatory to complete the Medical Questionnaire (Long Form).  
              Please download the Medical Questionnaire (Long Form) from the provided link, fill it out, and upload the completed form to proceed.</i></b>
              </p>

                <a href={pdfDownloadLink} download style={styles.link} target="blank">
                  Download PDF
                </a>

                <label>
                    Long Question Form:
                    <input
                      type="file"
                      name="longQues"
                      accept="application/pdf"
                      onChange={handleFileChange}
                    />
                    {imagePreviews.longQues && (
                      <div className="image-preview">
                        <img src={imagePreviews.longQues} alt="Long quest" />
                        <p>File uploaded</p>
                        <button
                          type="button"
                          onClick={() => handleRemoveImage("longQues")}
                        >
                          Change File
                        </button>
                      </div>
                    )}
                    {imageErrors.longQues && (
                      <span className="error">{imageErrors.longQues}</span>
                    )}
                  </label>
              </div>
            )} */}

            {/* Digital Verification - OTP Section */}
            {isDigital && !otpVerified && (
           <div style={{ padding: "20px", maxWidth: "400px", margin: "auto" }}>
           <h2>OTP Verification</h2>
     
           {/* Phone Number Input */}
           <input
             disabled
             type="text"
             placeholder="Enter 10-digit phone number"
             value={phoneNumber}
             onChange={handlePhoneChange}
             maxLength="10"
             style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
           />
           <button
             type="button"
             onClick={handleSendOTP}
             disabled={phoneNumber.length !== 10}
             style={{
               width: "100%",
               padding: "10px",
               backgroundColor: phoneNumber.length === 10 ? "#28a745" : "#ccc",
               color: "white",
               border: "none",
               cursor: phoneNumber.length === 10 ? "pointer" : "not-allowed",
             }}
           >
             {otpSent ? "OTP Sent" : "Send OTP"}
           </button>
     
           {/* OTP Input */}
           {otpSent && (
             <>
               <input
                 type="text"
                 placeholder="Enter OTP"
                 value={otp}
                 onChange={handleOtpChange}
                 maxLength="6"
                 style={{ width: "100%", padding: "8px", marginTop: "10px" }}
               />
               <button
                 type="button"
                 onClick={handleVerifyOTP}
                 disabled={otp.length !== 6}
                 style={{
                   width: "100%",
                   padding: "10px",
                   marginTop: "10px",
                   backgroundColor: otp.length === 6 ? "#007bff" : "#ccc",
                   color: "white",
                   border: "none",
                   cursor: otp.length === 6 ? "pointer" : "not-allowed",
                 }}
               >
                 Verify OTP
               </button>
     
               {/* Resend OTP */}
               <button
                 type="button"
                 onClick={handleResendOTP}
                 disabled={resendTimer > 0}
                 style={{
                   width: "100%",
                   padding: "10px",
                   marginTop: "10px",
                   backgroundColor: resendTimer === 0 ? "#dc3545" : "#ccc",
                   color: "white",
                   border: "none",
                   cursor: resendTimer === 0 ? "pointer" : "not-allowed",
                 }}
               >
                 {resendTimer === 0 ? "Resend OTP" : `Resend OTP in ${resendTimer}s`}
               </button>
             </>
           )}
     
           {/* Error Message */}
           {error && <p style={{ color: "red", marginTop: "10px" }}>{error}</p>}
     
           {/* Success Message */}
           {otpVerified && <p style={{ color: "green", marginTop: "10px" }}>OTP Verified ✅</p>}
         </div>
            )}

            {/* Health Questions (only if Digital Verification is chosen) */}
            {isDigital && otpVerified && (
  <div style={styles.dialogContent}>
    {healthQuestion.map((question) => (
      <div key={question.key} style={styles.question}>
        <label style={styles.label}>{question.label}</label>
        <div style={styles.radioGroup}>
          <label style={styles.radioLabel}>
            <input
              type="radio"
              name={question.key}
              value="yes"
              checked={responses[question.key] === "yes"}
              onChange={() => handleResponseChange(question.key, "yes")}
            />
            Yes
          </label>
          <label style={styles.radioLabel}>
            <input
              type="radio"
              name={question.key}
              value="no"
              checked={responses[question.key] === "no"}
              onChange={() => handleResponseChange(question.key, "no")}
            />
            No
          </label>
        </div>
      </div>
    ))}
  </div>
)}

  {/* Manual Form PDF Download */}
  {singleManualForm && (
              <div style={styles.pdfSection}>
               <p>
              <b><i>You have selected "Yes" to one or more questions in the Declaration of Good Health (DOGH). As a result, it is mandatory to complete the Medical Questionnaire (Long Form).  
              Please download the Medical Questionnaire (Long Form) from the provided link, fill it out, and upload the completed form to proceed.</i></b>
              </p>

                <a href={pdfDownloadLink} download style={styles.link} target="blank">
                  Download PDF
                </a>

                <label>
                    Long Question Form:
                    <input
                      type="file"
                      name="longQuestionnaire"
                      accept="application/pdf"
                      onChange={handleFileChange}
                    />
                    {imagePreviews.longQuestionnaire && (
                      <div className="image-preview">
                        <img src={imagePreviews.longQuestionnaire} alt="Long quest" />
                        <p>File uploaded</p>
                        <button
                          type="button"
                          onClick={() => handleRemoveImage("longQuestionnaire")}
                        >
                          Change File
                        </button>
                      </div>
                    )}
                    {imageErrors.longQuestionnaire && (
                      <span className="error">{imageErrors.longQuestionnaire}</span>
                    )}
                  </label>
              </div>
            )}

            {/* Form Actions */}
            <div style={styles.footer}>
  <button type="button" onClick={() => setOpen(false)} style={styles.buttonCancel}>
    Cancel
  </button>

  <button
    type="button"
    onClick={() => {
      handleSubmitTnc();
      setOpen(false); // Close dialog after saving
    }}
    disabled={!isHealthFormValid}
    style={{
      ...styles.buttonSave,
      backgroundColor: isHealthFormValid ? "#28a745" : "#ccc",
      cursor: isHealthFormValid ? "pointer" : "not-allowed",
    }}
  >
    Save
  </button>
</div>
          </div>
        </div>
      )}
    </div>
                </div>
              )}

<br />

<div className="pagination-controls">
  {currentPage === 1 && (
    <button className={
    areRequiredFieldsFilled() && !ageLimitExceed ? "" : "grey-button-next"}
      type="button"
      onClick={() => handlePageChange(2)}
      disabled={!areRequiredFieldsFilled() || ageLimitExceed}
    >
      Next
    </button>
  )}

  {currentPage === 2 && (
    <>
      <button type="button" onClick={() => handlePageChange(1)}>
        Previous
      </button>

      {totalLoanAmount > 200000 ? (
        <button
          className={
            areRequiredFieldsFilledForHealQuestionButton() && areLoanDetailsFieldsFilled()
              ? ""
              : "grey-button-next"
          }
          disabled={
            !areRequiredFieldsFilledForHealQuestionButton() || !areLoanDetailsFieldsFilled()
          }
          type="submit"
        >
          Submit
        </button>
      ) : (
        <button
        className={
          areLoanDetailsFieldsFilled()
            ? ""
            : "grey-button-next"
        }
        disabled={
          !areLoanDetailsFieldsFilled()
        }
        type="submit">
      
          Submit
        </button>
      )}
    </>
  )}
</div>

            </form>
          </div>
        </>
      )}
    </>
  );
};
export default TirumalaDC;